module.exports = {"apiBase":"http://139.198.125.57:4880/v1","wsBase":"ws://192.168.32.52/v1","profile":"cube"}


//////////////////
// WEBPACK FOOTER
// ./config/dev.json
// module id = 2390
// module chunks = 1